var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('item-show-view',{scopedSlots:_vm._u([{key:"default",fn:function(_){return [(_vm.wrapped)?_c('v-row',[_c('v-col',[_c('subcard',[_vm._t("default",null,null,_)],2)],1)],1):_c('div',[_vm._t("default",null,null,_)],2)]}}],null,true)})}
var staticRenderFns = []

export { render, staticRenderFns }